class CardAvatarController {
  constructor() {}
}

export default CardAvatarController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardAvatar/cardAvatar.controller.js